import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Showcase from '../components/Showcase';
import Features from '../components/Features';
import Contact from '../components/Contact';

const HomePage: React.FC = () => {
  const userLogin = useSelector((state: appState) => state.userLogin);
  const { userData } = userLogin;

  const navigate = useNavigate();

  useEffect(() => {
    if (userData) {
      navigate('/account');
    }
  }, [navigate, userData]);

  return (
    <main>
      <Showcase />
      <Features />
      <Contact />
    </main>
  );
};

export default HomePage;
